define.alias("shared/components/shared/ui/notification-banner", "calendar/components/shared/ui/notification-banner");